import React, { useSyncExternalStore } from 'react';
import i18n from '@ohif/i18n';
import { Link, useLocation } from 'react-router-dom';
import ViewerLayout from '@ohif/extension-default/src/ViewerLayout';
import clinicalSession from './services/clinicalSession';
import clinicalApi from './services/clinicalApi';
import launchSession from './services/launchSession';
import { RecordPanel } from './components/RecordDetails';
import { localizeClinicalSeriesSorts } from './utils/localizeToolbar';
import ClinicalToolButtonList from './components/ClinicalToolButtonList';

export { LoginPage, WorklistPage, SessionGate } from './components/ClinicalPages';
export { default as LaunchPage } from './components/LaunchPage';
export { default as clinicalSession } from './services/clinicalSession';
export { default as launchSession } from './services/launchSession';
export { safeReturnPath } from './services/clinicalApi';
export { localizeClinicalToolbar, localizeClinicalSeriesSorts } from './utils/localizeToolbar';
const id = '@ohif/extension-clinical';
function activeSession() {
  return window.location.pathname.endsWith('/clinical/launch') ? launchSession : clinicalSession;
}
export default {
  id,
  async preRegistration({ servicesManager, appConfig }) {
    // This deployment is Chinese, independent of a cached language from another product.
    await i18n.initializing;
    i18n.addResourceBundle(
      'zh',
      'Buttons',
      { 'Click to toggle on or off': '点击开启或关闭' },
      true,
      true
    );
    await i18n.changeLanguage('zh');
    const config = appConfig.clinical || {};
    clinicalSession.configure(config);
    clinicalApi.configure(config);
    launchSession.configure(config);
    appConfig.httpErrorHandler = error => {
      if ((error?.status ?? error?.response?.status ?? error?.target?.status) === 401) {
        activeSession().clearToken();
      }
    };
    servicesManager.services.userAuthenticationService.setServiceImplementation({
      getAuthorizationHeader: () => activeSession().getAuthorizationHeader(),
      handleUnauthenticated: () => activeSession().clearToken(),
      getState: () => activeSession().getSnapshot(),
    });
  },
  getPanelModule() {
    return [
      {
        name: 'record',
        iconName: 'tab-patient-info',
        iconLabel: '资料',
        label: '报告与历史',
        component: RecordPanel,
      },
    ];
  },
  getToolbarModule() {
    return [{ name: 'clinical.toolButtonList', defaultComponent: ClinicalToolButtonList }];
  },
  getLayoutTemplateModule(params) {
    function ClinicalLayout(props) {
      const location = useLocation();
      const session = useSyncExternalStore(clinicalSession.subscribe, clinicalSession.getSnapshot);
      const embedded = location.pathname.endsWith('/clinical/launch');
      return React.createElement(
        'div',
        { className: `clinical-reader${embedded ? ' clinical-reader--embedded' : ''}` },
        !embedded &&
          React.createElement(
            'header',
            { className: 'clinical-reader-navigation' },
            React.createElement(
              Link,
              { to: '/clinical/worklist', 'data-cy': 'clinical-reader-back' },
              '返回检查列表'
            ),
            React.createElement('span', null, '临床阅片'),
            React.createElement(
              'div',
              null,
              session?.username,
              React.createElement(
                'button',
                { onClick: clinicalSession.clearToken, 'data-cy': 'clinical-reader-logout' },
                '退出登录'
              )
            )
          ),
        React.createElement(
          'div',
          { className: 'clinical-imaging', 'data-cy': 'clinical-imaging' },
          React.createElement(ViewerLayout, { ...params, ...props })
        )
      );
    }
    return [{ name: 'viewer', component: ClinicalLayout }];
  },
  getCustomizationModule({ appConfig }) {
    return [
      {
        name: 'global',
        value: {
          'studyBrowser.sortFunctions': { $apply: localizeClinicalSeriesSorts },
          'studyBrowser.thumbnailMenuItems': { $apply: localizeClinicalSeriesSorts },
        },
      },
      {
        name: 'clinical',
        value: {
          'ohif.hotkeyBindings': appConfig.hotkeys || [],
          'panelSegmentation.disableEditing': true,
        },
      },
    ];
  },
};
